// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filtre-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.filtre-modal {
  background: #FFFDFC;
  border-radius: 8px;
  padding: 2rem;
  width: 100%;
  max-width: 60rem;
  max-height: 90vh;
  overflow-y: auto;
}

.filtre-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.filtre-header h2 {
  font-size: 2.4rem;
  color: #2C3948;
}

.close-button {
  background: none;
  border: none;
  font-size: 2.4rem;
  cursor: pointer;
  color: #6B7280;
}

.filtre-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.filtre-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.filtre-section h3 {
  font-size: 1.6rem;
  color: #2C3948;
}

.date-range {
  display: flex;
  gap: 1rem;
}

.price-range {
  display: grid;
  /* align-items: center; */
  gap: 1rem;
}

.filtre-section select,
.filtre-section input {
  padding: 1rem;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  font-size: 1.4rem;
}

.filtre-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #E5E7EB;
}

.price-slider-container {
  width: 100%;
  padding: 0 1rem;
}

.price-inputs {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.price-inputs input[type="number"] {
  width: 100px;
  padding: 0.8rem;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  font-size: 1.4rem;
  text-align: center;
}

.price-range-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  padding: 2rem 2rem 2rem 0;
}

.price-range-container button.third.small {
  width: fit-content;
}

.price-values {
  display: flex;
  /* justify-content: ; */
  margin-bottom: 1rem;
  font-size: 1.4rem;
  color: #2C3948;
}

.slider-container {
  position: relative;
  width: 100%;
  height: 4px;
  margin: 2rem 0;
}

.slider-container input {
    border: none
}

.slider-track {
  position: absolute;
  width: 100%;
  height: 4px;
  background: #E5E7EB;
  border-radius: 2px;
}

.slider {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -webkit-appearance: none;
  pointer-events: none;
  width: 100%;
  height: 100%;
  background: none;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  pointer-events: all;
  width: 16px;
  height: 16px;
  background: #2C3948;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid #FFFDFC;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: #2C3948;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid #FFFDFC;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.price-labels {
  display: none;
}

.reset-button {
  margin-top: 1rem;
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  background: #FFFDFC;
  color: #2C3948;
  font-size: 1.4rem;
  cursor: pointer;
}

.reset-button:hover {
  background: #F3F4F6;
}

/* Active slider color */
.slider-container .slider:nth-child(1), .slider-container .slider:nth-child(2) {
  z-index: 1;
}

.price-range {
  width: 100%;
}

.inputs-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  align-items: end;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.input-group label {
  font-size: 13px;
  font-weight: 500;
  color: #444;
}

.price-input {
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/composants/FiltreDeCommande/FiltreDeCommande.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;IACI;AACJ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb","sourcesContent":[".filtre-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.filtre-modal {\n  background: #FFFDFC;\n  border-radius: 8px;\n  padding: 2rem;\n  width: 100%;\n  max-width: 60rem;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.filtre-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.filtre-header h2 {\n  font-size: 2.4rem;\n  color: #2C3948;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 2.4rem;\n  cursor: pointer;\n  color: #6B7280;\n}\n\n.filtre-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.filtre-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.filtre-section h3 {\n  font-size: 1.6rem;\n  color: #2C3948;\n}\n\n.date-range {\n  display: flex;\n  gap: 1rem;\n}\n\n.price-range {\n  display: grid;\n  /* align-items: center; */\n  gap: 1rem;\n}\n\n.filtre-section select,\n.filtre-section input {\n  padding: 1rem;\n  border: 1px solid #E5E7EB;\n  border-radius: 4px;\n  font-size: 1.4rem;\n}\n\n.filtre-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid #E5E7EB;\n}\n\n.price-slider-container {\n  width: 100%;\n  padding: 0 1rem;\n}\n\n.price-inputs {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.price-inputs input[type=\"number\"] {\n  width: 100px;\n  padding: 0.8rem;\n  border: 1px solid #E5E7EB;\n  border-radius: 4px;\n  font-size: 1.4rem;\n  text-align: center;\n}\n\n.price-range-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  width: 100%;\n  padding: 2rem 2rem 2rem 0;\n}\n\n.price-range-container button.third.small {\n  width: fit-content;\n}\n\n.price-values {\n  display: flex;\n  /* justify-content: ; */\n  margin-bottom: 1rem;\n  font-size: 1.4rem;\n  color: #2C3948;\n}\n\n.slider-container {\n  position: relative;\n  width: 100%;\n  height: 4px;\n  margin: 2rem 0;\n}\n\n.slider-container input {\n    border: none\n}\n\n.slider-track {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: #E5E7EB;\n  border-radius: 2px;\n}\n\n.slider {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  -webkit-appearance: none;\n  pointer-events: none;\n  width: 100%;\n  height: 100%;\n  background: none;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  pointer-events: all;\n  width: 16px;\n  height: 16px;\n  background: #2C3948;\n  border-radius: 50%;\n  cursor: pointer;\n  border: 2px solid #FFFDFC;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.slider::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  background: #2C3948;\n  border-radius: 50%;\n  cursor: pointer;\n  border: 2px solid #FFFDFC;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.price-labels {\n  display: none;\n}\n\n.reset-button {\n  margin-top: 1rem;\n  width: 100%;\n  padding: 0.8rem;\n  border: 1px solid #E5E7EB;\n  border-radius: 4px;\n  background: #FFFDFC;\n  color: #2C3948;\n  font-size: 1.4rem;\n  cursor: pointer;\n}\n\n.reset-button:hover {\n  background: #F3F4F6;\n}\n\n/* Active slider color */\n.slider-container .slider:nth-child(1), .slider-container .slider:nth-child(2) {\n  z-index: 1;\n}\n\n.price-range {\n  width: 100%;\n}\n\n.inputs-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  align-items: end;\n}\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.input-group label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #444;\n}\n\n.price-input {\n  padding: 6px 8px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 14px;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
